import hearingReport from "./hearingReport.vue";
export default hearingReport;
